module.exports = __webpack_public_path__ + "static/media/icon-exclamation.18c811e0.svg";